"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var es_cookie_1 = require("es-cookie");
var react_router_dom_1 = require("react-router-dom");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var condo_brain_1 = require("condo-brain");
var Schedule_1 = __importDefault(require("@mui/icons-material/Schedule"));
var EventAvailable_1 = __importDefault(require("@mui/icons-material/EventAvailable"));
var moment_1 = __importDefault(require("moment"));
require("./styles/application.scss");
require("./styles/parking.scss");
var minutesToReadable = function (t) {
    var hours = Math.floor(t / 60);
    var hourText = hours > 1 ? 'hours' : 'hour';
    var minutes = t % 60;
    var timeText = '';
    if (hours > 0) {
        timeText = "".concat(hours, " ").concat(hourText, " ");
    }
    if (minutes > 0) {
        timeText = "".concat(timeText, " ").concat(minutes, " minutes");
    }
    return timeText;
};
var addMinutes = function (date, min) {
    var updatedDate = new Date(date);
    updatedDate.setMinutes(date.getMinutes() + min);
    return updatedDate;
};
var roundToMinuteInterval = function (date, interval) {
    var time = (date.getHours() * 60) + date.getMinutes();
    var rounded = Math.round(time / interval) * interval;
    var roundedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), Math.floor(rounded / 60), rounded % 60);
    return roundedDate;
};
var formatDate = function (date) {
    var month = date.toLocaleDateString().split('/')[0];
    var day = date.toLocaleDateString().split('/')[1];
    var year = date.toLocaleDateString().split('/')[2];
    if (parseInt(month, 10) < 10) {
        month = "0".concat(month);
    }
    if (parseInt(day, 10) < 10) {
        day = "0".concat(day);
    }
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var formatTime = function (date) {
    var options = { hour12: false, hour: '2-digit', minute: '2-digit' };
    return date.toLocaleTimeString([], options);
};
function Resevation() {
    var _this = this;
    var _a = (0, react_1.useState)(roundToMinuteInterval(new Date(), 15)), selectedStartDate = _a[0], setSelectedStartDateChange = _a[1];
    var _b = (0, react_1.useState)(addMinutes(selectedStartDate, 30)), selectedEndDate = _b[0], setSelectedEndDateChange = _b[1];
    var _c = (0, react_1.useState)(''), amenity = _c[0], setAmenity = _c[1];
    var _d = (0, react_1.useState)([]), amenities = _d[0], setAmenities = _d[1];
    var _e = (0, react_1.useState)([]), displayAmenities = _e[0], setDisplayAmenities = _e[1];
    var _f = (0, react_1.useState)([]), answers = _f[0], setAnswers = _f[1];
    var _g = (0, react_1.useState)([]), questions = _g[0], setQuestions = _g[1];
    var _h = (0, react_1.useState)(false), thanks = _h[0], setThanks = _h[1];
    var _j = (0, react_1.useState)(60), amenityTime = _j[0], setAmenityTime = _j[1];
    var _k = (0, react_1.useState)(''), errorMessage = _k[0], setErrorMessage = _k[1];
    var _l = (0, react_1.useState)(null), availability = _l[0], setAvailability = _l[1];
    var _m = (0, react_1.useState)(''), selectedAmenityName = _m[0], setSelectedAmenityName = _m[1];
    var _o = (0, react_1.useState)(false), auth = _o[0], setAuth = _o[1];
    var _p = (0, react_1.useState)(false), vaccinated = _p[0], setVaccinated = _p[1];
    var userManager = new condo_brain_1.UserManager();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var currentDate = new Date();
    var maxDate = new Date(currentDate.getTime() - (currentDate.getTimezoneOffset() * 60000) + (7 * 24 * 60 * 60 * 1000))
        .toISOString()
        .split('T')[0]
        .toString();
    var reserve = function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('reservation[resource_id]', String(amenity));
        formData.append('reservation[start_time]', String(selectedStartDate));
        formData.append('reservation[end_time]', String(selectedEndDate));
        formData.append('answers[]', JSON.stringify(answers));
        userManager.createReservation(formData)
            .then(function (response) {
            if (response.success === true) {
                setThanks(true);
                setSelectedStartDateChange(new Date());
                setSelectedEndDateChange(new Date());
                setAmenity('');
                setAnswers([]);
                setErrorMessage('');
            }
            else if (response.error === 'Unprocessable Entity') {
                var err = 'Please make sure you have filled out the form correctly. '
                    + 'If you could not check every box, then you cannot use this amenity.';
                setErrorMessage(err);
            }
            else if (response.error) {
                setErrorMessage(response.error);
            }
        });
    };
    var fetchAmenities = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (userManager.getAmenities().then(function (result) {
                    var filteredAmenities = result.filter(function (filterAmenity) { return (filterAmenity.visible); });
                    setAmenities(filteredAmenities);
                    var amenityQuestions = [];
                    Object.keys(filteredAmenities).forEach(function (i) {
                        var a = filteredAmenities[Number(i)];
                        amenityQuestions[a.id] = a.questions;
                    });
                    setQuestions(amenityQuestions);
                }))];
        });
    }); };
    var findReservations = function () {
        if (!amenity || !selectedStartDate) {
            return;
        }
        userManager.findReservations(selectedStartDate, Number(amenity)).then(function (result) {
            if (result.length === 0) {
                setAvailability(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.AlertTitle, null,
                        selectedAmenityName,
                        '  ',
                        "Availability"),
                    "No current bookings.",
                    react_1.default.createElement("p", null,
                        minutesToReadable(amenityTime),
                        '  ',
                        "limit.")));
            }
            else {
                // eslint-disable-next-line
                result.sort(function (r1, r2) { return r1.startTime < r2.startTime ? -1 : 1; });
                var times_1 = [];
                var dateToShow_1 = (0, moment_1.default)(selectedStartDate).local().format('YYYY-MM-DD');
                Object.keys(result).forEach(function (a) {
                    var pos = Number(a);
                    var resultStartDate = (0, moment_1.default)(result[pos].startTime).local().format('YYYY-MM-DD');
                    if (resultStartDate !== dateToShow_1) {
                        return;
                    }
                    times_1.push("".concat((0, moment_1.default)(result[pos].startTime).format('LT'), " - ").concat((0, moment_1.default)(result[pos].endTime).format('LT')));
                });
                setAvailability(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.AlertTitle, null,
                        selectedAmenityName,
                        ' ',
                        "has a",
                        ' ',
                        react_1.default.createElement("strong", null,
                            minutesToReadable(amenityTime),
                            ' ',
                            "limit"),
                        ",",
                        ' ',
                        "and is already booked at these times:"),
                    react_1.default.createElement(material_1.List, null, times_1.map(function (time) { return (react_1.default.createElement(material_1.ListItem, { style: { paddingTop: 0, paddingBottom: 0 } },
                        react_1.default.createElement(material_1.ListItemText, { style: { marginBottom: 0, marginTop: 0 }, primary: time }))); }))));
            }
        });
    };
    var filterVaccinatedAmenities = function () {
        if (auth && !vaccinated) {
            var filteredAmenities = amenities.filter(function (filterAmenity) { return (!filterAmenity.vaccine); });
            setDisplayAmenities(filteredAmenities);
        }
        else {
            setDisplayAmenities(amenities);
        }
    };
    var checkLogin = function () {
        var token = (0, es_cookie_1.get)('token');
        if (token) {
            userManager.validateToken(token).then(function (_result) {
                if (userManager.loggedIn) {
                    setAuth(true);
                    setVaccinated(userManager.isVaccinated);
                }
                else {
                    setAuth(false);
                }
            });
        }
    };
    (0, react_1.useEffect)(function () {
        fetchAmenities();
    }, [amenities.length]);
    (0, react_1.useEffect)(function () {
        filterVaccinatedAmenities();
    }, [amenities.length, auth]);
    (0, react_1.useEffect)(function () {
        findReservations();
    }, [amenity, selectedStartDate]);
    (0, react_1.useEffect)(function () {
        if (!userManager) {
            return;
        }
        checkLogin();
        var timer = setTimeout(function () {
            checkLogin();
            clearTimeout(timer);
        }, 1000);
    }, [auth]);
    var handleAmenityChange = function (event) {
        var reserveAmenity = event.target.value;
        setAmenity(reserveAmenity);
        Object.keys(amenities).forEach(function (a) {
            var loopAmenity = amenities[Number(a)];
            if (String(loopAmenity.id) === event.target.value) {
                setSelectedAmenityName(loopAmenity.name);
                setAmenityTime(loopAmenity.timeLimit);
            }
        });
    };
    var handleAnswerChange = function (event) {
        if (event.target.checked) {
            var currentAnswers = answers;
            currentAnswers[Number(event.target.name)] = true;
            setAnswers(currentAnswers);
        }
        else {
            var currentAnswers = answers;
            currentAnswers[Number(event.target.name)] = false;
            setAnswers(currentAnswers);
        }
    };
    var handleNativeDateChange = function (date) {
        var constDate = new Date(date);
        var tzo = new Date().getTimezoneOffset();
        var changedDate = (0, moment_1.default)(constDate).add(tzo, 'm').toDate();
        var startDate = new Date(changedDate.getFullYear(), changedDate.getMonth(), changedDate.getDate(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getHours()) || new Date().getHours(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getMinutes()) || new Date().getMinutes());
        setSelectedStartDateChange(startDate);
        var endDate = new Date(changedDate.getFullYear(), changedDate.getMonth(), changedDate.getDate(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getHours()) || new Date().getHours(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getMinutes()) || new Date().getMinutes());
        setSelectedEndDateChange(endDate);
    };
    var handleNativeStartTimeChange = function (date) {
        var _a = date.split(':'), hour = _a[0], minute = _a[1];
        var startDate = new Date((selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getFullYear()) || new Date().getFullYear(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getMonth()) || new Date().getMonth(), (selectedStartDate === null || selectedStartDate === void 0 ? void 0 : selectedStartDate.getDate()) || new Date().getDate(), Number(hour), Number(minute));
        setSelectedStartDateChange(roundToMinuteInterval(startDate, 15));
    };
    var handleNativeEndTimeChange = function (date) {
        var _a = date.split(':'), hour = _a[0], minute = _a[1];
        var endDate = new Date((selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getFullYear()) || new Date().getFullYear(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getMonth()) || new Date().getMonth(), (selectedEndDate === null || selectedEndDate === void 0 ? void 0 : selectedEndDate.getDate()) || new Date().getDate(), Number(hour), Number(minute));
        setSelectedEndDateChange(roundToMinuteInterval(endDate, 15));
    };
    var useStyles = (0, makeStyles_1.default)(function () { return (0, createStyles_1.default)({
        root: {
            '& .MuiTextField-root': {
                width: '100%',
            },
        },
    }); });
    var classes = useStyles();
    return (react_1.default.createElement("div", null,
        thanks && (react_1.default.createElement("div", { className: "section flex-grow" },
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 1 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement("h4", { className: "center" }, "Amenity reserved"),
                    react_1.default.createElement("p", { className: "center" },
                        "Thank you!",
                        '  ',
                        react_1.default.createElement("span", { role: "img", "aria-label": "" }, "\uD83E\uDD1F"),
                        "Your reservation has been confirmed!",
                        '  ')),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                    react_1.default.createElement(material_1.Button, { variant: "contained", sx: {
                            backgroundColor: '#f37f30',
                            color: 'white',
                            marginBottom: '20px',
                        }, onClick: function () {
                            setAvailability(null);
                            setThanks(false);
                            setSelectedStartDateChange(roundToMinuteInterval(new Date(), 15));
                            setSelectedEndDateChange(roundToMinuteInterval(addMinutes(selectedStartDate, 30), 15));
                        }, startIcon: react_1.default.createElement(EventAvailable_1.default, null), type: "submit" }, "Make Another Reservation")),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                    react_1.default.createElement(material_1.Button, { variant: "contained", onClick: function () { return navigate('/myreservations'); }, sx: {
                            backgroundColor: '#f37f30',
                            color: 'white',
                            marginBottom: '20px',
                        }, startIcon: react_1.default.createElement(Schedule_1.default, null), type: "submit" }, "My Reservations"))))),
        !thanks && (react_1.default.createElement("form", { className: classes.root, noValidate: true, autoComplete: "off", onSubmit: reserve },
            react_1.default.createElement("div", { className: "section flex-grow" },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement("h4", { className: "center" }, "Reserve an Amenity"),
                        errorMessage !== '' && (react_1.default.createElement(material_1.Alert, { severity: "error" },
                            react_1.default.createElement(material_1.AlertTitle, null, "Error"),
                            errorMessage)),
                        auth && !vaccinated && (react_1.default.createElement(material_1.Alert, { severity: "error" },
                            react_1.default.createElement(material_1.AlertTitle, null, "Some Amenities Are Unavailable"),
                            "Please submit your vaccine information to property management to access all amenities."))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.InputLabel, { htmlFor: "age-native-simple" }, "Amenity"),
                        react_1.default.createElement(material_1.Select, { native: true, value: amenity, onChange: handleAmenityChange, inputProps: {
                                name: 'amenity',
                                id: 'amenity',
                            }, style: { width: '100%' } },
                            react_1.default.createElement("option", { "aria-label": "None", value: "" }),
                            displayAmenities.map(function (amenityOption) { return (react_1.default.createElement("option", { key: amenityOption.id, value: String(amenityOption.id) }, amenityOption.name)); }))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "start", label: "Date", type: "date", inputProps: {
                                max: maxDate,
                            }, defaultValue: formatDate(selectedStartDate), onChange: function (e) { return handleNativeDateChange(e.target.value); }, InputLabelProps: {
                                shrink: true,
                            } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "startTime", label: "Start Time", type: "time", value: formatTime(roundToMinuteInterval(selectedStartDate, 15)), onChange: function (e) { return handleNativeStartTimeChange(e.target.value); }, InputLabelProps: {
                                shrink: true,
                            } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 6 },
                        react_1.default.createElement(material_1.TextField, { id: "endTime", label: "End Time", type: "time", value: formatTime(roundToMinuteInterval(selectedEndDate, 15)), onChange: function (e) { return handleNativeEndTimeChange(e.target.value); }, InputLabelProps: {
                                shrink: true,
                            } })),
                    availability && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Alert, { severity: "info" }, availability))),
                    amenity !== '' && questions[Number(amenity)].map(function (questionOption) { return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, key: questionOption.id },
                        react_1.default.createElement(material_1.FormControlLabel, { control: (react_1.default.createElement(material_1.Checkbox, { checked: answers[questionOption.id], onChange: handleAnswerChange, name: String(questionOption.id), color: "primary" })), label: questionOption.question }))); }),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.Typography, null,
                            "Please ensure that you follow the posted instructions as well as complying with the",
                            ' ',
                            react_1.default.createElement(material_1.Link, { href: "https://wscc556.frontsteps.com/folders/", target: "_blank", rel: "noopener" }, "Arrow Lofts condo rules"),
                            ".")),
                    amenity && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center" },
                        react_1.default.createElement(material_1.Button, { variant: "contained", type: "submit", sx: {
                                backgroundColor: '#f37f30',
                                color: 'white',
                                marginBottom: '20px',
                            }, endIcon: react_1.default.createElement(material_1.Icon, null, "add") },
                            "Reserve",
                            selectedAmenityName && (react_1.default.createElement(react_1.default.Fragment, null,
                                '  ',
                                selectedAmenityName)))))))))));
}
exports.default = Resevation;
